// https://stackoverflow.com/a/32178833
// 1 -> 1.00
// 1.1 -> 1.10
// 1.11 -> 1.11
// 1.111 -> 1.11
function decimalAmount(value: number, decimalPlaces = 2) {
    return Number(Math.round(parseFloat(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces).toFixed(decimalPlaces);
}

// 1 -> $1.00
// 1.1 -> $1.10
// 1.11 -> $1.11
// 1.111 -> $1.11
function currencyAmount(value: number, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
}

export {
    decimalAmount,
    currencyAmount,
};